import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/


var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var modules_e0508c7c = {
  "responsive": "Img_module_responsive__e0e919b3"
};
var _excluded = ["renderImage"],
    _excluded2 = ["className", "wrapperClassName", "src", "source", "alt", "title", "autoResponsive"];

var Img = function Img(_ref) {
  var renderImage = _ref.renderImage,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (typeof renderImage === "function") {
    return renderImage({
      props: props
    });
  }

  var className = props.className,
      wrapperClassName = props.wrapperClassName,
      src = props.src,
      source = props.source,
      alt = props.alt,
      title = props.title,
      autoResponsive = props.autoResponsive,
      restProps = _objectWithoutPropertiesLoose(props, _excluded2);

  if (src) {
    return /*#__PURE__*/React.createElement("img", _extends({
      className: classnames(autoResponsive && modules_e0508c7c.responsive, wrapperClassName),
      src: src,
      alt: alt,
      title: title
    }, restProps));
  }

  if (source) {
    return /*#__PURE__*/React.createElement("picture", restProps, /*#__PURE__*/React.createElement("source", {
      srcSet: source.srcSet,
      sizes: source.sizes
    }), /*#__PURE__*/React.createElement("img", _extends({
      className: classnames(autoResponsive && modules_e0508c7c.responsive, wrapperClassName),
      src: source.src,
      srcSet: source.srcSet,
      sizes: source.sizes,
      alt: alt,
      title: title
    }, restProps)));
  }

  console.error("Img requires either src or source as a prop");
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

Img.defaultProps = {
  className: undefined,
  wrapperClassName: undefined,
  src: undefined,
  source: undefined,
  title: undefined,
  autoResponsive: true,
  renderImage: undefined
};
var modules_b15cf1eb = {
  "grid": "MultiImageBlock_module_grid__23602d0b",
  "grid__item": "MultiImageBlock_module_grid__item__23602d0b",
  "grid--two": "MultiImageBlock_module_grid_Two__23602d0b",
  "grid--two_stack": "MultiImageBlock_module_grid_Two_stack__23602d0b",
  "grid--three": "MultiImageBlock_module_grid_Three__23602d0b",
  "grid--four": "MultiImageBlock_module_grid_Four__23602d0b",
  "image": "MultiImageBlock_module_image__23602d0b"
};

var MultiImageBlock = function MultiImageBlock(_ref) {
  var className = _ref.className,
      stacked = _ref.stacked,
      images = _ref.images,
      renderImage = _ref.renderImage;
  var rows = [];
  var numberOfChildren = images.length;

  if (numberOfChildren === 1) {
    rows = [{
      items: images
    }];
  } else if (numberOfChildren === 2) {
    if (stacked) {
      rows = [{
        className: modules_b15cf1eb["grid--two_stack"],
        items: images
      }];
    } else {
      rows = [{
        className: modules_b15cf1eb["grid--two"],
        items: images
      }];
    }
  } else if (numberOfChildren === 3) {
    rows = [{
      className: modules_b15cf1eb["grid--three"],
      items: images
    }];
  } else if (numberOfChildren === 4) {
    rows = [{
      className: modules_b15cf1eb["grid--four"],
      items: images
    }];
  } else {
    var mod3 = numberOfChildren % 3;
    var mod4 = numberOfChildren % 4;

    if (mod3 === 0 || mod4 === 0) {
      if (mod3 === 0) {
        images.forEach(function (image, index) {
          var currentIndex = index + 1;
          var numberOfRows = rows.length;

          if (numberOfRows * 3 + 1 === currentIndex) {
            rows.push({
              className: modules_b15cf1eb["grid--three"],
              items: [image]
            });
          } else {
            rows[numberOfRows - 1] = {
              className: modules_b15cf1eb["grid--three"],
              items: [].concat(rows[numberOfRows - 1].items, [image])
            };
          }
        });
      } else if (mod4 === 0) {
        images.forEach(function (image, index) {
          var currentIndex = index + 1;
          var numberOfRows = rows.length;

          if (numberOfRows * 4 + 1 === currentIndex) {
            rows.push({
              className: modules_b15cf1eb["grid--four"],
              items: [image]
            });
          } else {
            rows[numberOfRows - 1] = {
              className: modules_b15cf1eb["grid--four"],
              items: [].concat(rows[numberOfRows - 1].items, [image])
            };
          }
        });
      }
    } else if (mod3 > mod4 || mod3 === mod4) {
      var numberOfRepeats = Math.floor(numberOfChildren / 3); // number of times the divisor in numerator

      var remaining = numberOfChildren - numberOfRepeats * 3; // number remaining after divisor in numerator

      images.forEach(function (image, index) {
        var currentIndex = index + 1;

        if (numberOfChildren - currentIndex < remaining) {
          return;
        }

        var numberOfRows = rows.length;

        if (numberOfRows * 3 + 1 === currentIndex) {
          rows.push({
            className: modules_b15cf1eb["grid--three"],
            items: [image]
          });
        } else {
          rows[numberOfRows - 1] = {
            className: modules_b15cf1eb["grid--three"],
            items: [].concat(rows[numberOfRows - 1].items, [image])
          };
        }
      });

      switch (remaining) {
        case 1:
          rows.push({
            items: images.slice(numberOfChildren - remaining)
          });
          break;

        case 2:
          rows.push({
            className: modules_b15cf1eb["grid--two"],
            items: images.slice(numberOfChildren - remaining)
          });
          break;
      }
    } else if (mod3 < mod4 || mod3 === mod4) {
      var _numberOfRepeats = Math.floor(numberOfChildren / 4);

      var _remaining = numberOfChildren - _numberOfRepeats * 4;

      images.forEach(function (image, index) {
        var currentIndex = index + 1;

        if (numberOfChildren - currentIndex < _remaining) {
          return;
        }

        var numberOfRows = rows.length;

        if (numberOfRows * 4 + 1 === currentIndex) {
          rows.push({
            className: modules_b15cf1eb["grid--four"],
            items: [image]
          });
        } else {
          rows[numberOfRows - 1] = {
            className: modules_b15cf1eb["grid--four"],
            items: [].concat(rows[numberOfRows - 1].items, [image])
          };
        }
      });

      switch (_remaining) {
        case 1:
          rows.push({
            items: images.slice(numberOfChildren - _remaining)
          });
          break;

        case 2:
          rows.push({
            className: modules_b15cf1eb["grid--two"],
            items: images.slice(numberOfChildren - _remaining)
          });
          break;

        case 3:
          rows.push({
            className: modules_b15cf1eb["grid--three"],
            items: images.slice(numberOfChildren - _remaining)
          });
          break;
      }
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(className)
  }, rows.map(function (row) {
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(modules_b15cf1eb.grid, row.className)
    }, row.items.map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        className: classnames(modules_b15cf1eb.grid__item, className)
      }, renderImage(_extends({}, item, {
        className: classnames(item.className, modules_b15cf1eb.image)
      })));
    }));
  }));
};

MultiImageBlock.displayName = "MultiImageBlock";
MultiImageBlock.defaultProps = {
  className: undefined,
  stacked: undefined,
  renderImage: function renderImage(image) {
    return /*#__PURE__*/React.createElement(Img, {
      className: image.className,
      wrapperClassName: image.className,
      src: image.src,
      source: image.source,
      alt: image.alt
    });
  }
};
export default MultiImageBlock;
export { MultiImageBlock };